<div class="education-detail" *ngIf="education">
  <!-- Colored hero background -->
  <div class="education-detail__hero"></div>

  <div class="education-detail__body">
    <button class="education-detail__back" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>
      <span>{{ 'shared.back' | translate }}</span>
    </button>

    <!-- Main card -->
    <div class="education-detail__card">
      <div class="education-detail__header">
        <div class="education-detail__institution">{{ 'educations.detail.institution_prefix' | translate }} {{ education.institution }}</div>
        <h1 class="education-detail__title">{{ education.title }}</h1>
      </div>

      <div class="education-detail__layout">
        <!-- Metrics grid -->
        <div class="education-detail__metrics">
          <div class="education-detail__metrics-grid">
            <div class="education-detail__metric">
              <div class="education-detail__metric-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div>
                <div class="education-detail__metric-label">{{ 'educations.detail.study_duration' | translate }}</div>
                <div class="education-detail__metric-value">{{ education.duration }}</div>
              </div>
            </div>

            <div class="education-detail__metric">
              <div class="education-detail__metric-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
                </svg>
              </div>
              <div>
                <div class="education-detail__metric-label">{{ 'educations.detail.work_level' | translate }}</div>
                <div class="education-detail__metric-value">{{ education.level }}</div>
              </div>
            </div>

            <div class="education-detail__metric">
              <div class="education-detail__metric-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div>
                <div class="education-detail__metric-label">{{ 'educations.detail.learning_formats' | translate }}</div>
                <div class="education-detail__metric-value">{{ education.format }}</div>
              </div>
            </div>

            <div class="education-detail__metric">
              <div class="education-detail__metric-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/>
                </svg>
              </div>
              <div>
                <div class="education-detail__metric-label">{{ 'educations.detail.diploma_type' | translate }}</div>
                <div class="education-detail__metric-value">{{ education.diploma }}</div>
              </div>
            </div>

            <div class="education-detail__metric education-detail__metric--wide" *ngIf="education.accreditation">
              <div class="education-detail__metric-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <div>
                <div class="education-detail__metric-label">{{ 'educations.detail.quality_mark' | translate }}</div>
                <span class="education-detail__accreditation-badge">{{ education.accreditation }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Logo placeholder -->
        <div class="education-detail__logo">
          <img src="/skilld_rgb_logo_pos_144dpi.jpg" alt="Skilld logo" />
        </div>
      </div>
    </div>

    <!-- Description card -->
    <div class="education-detail__description-card">
      <div class="education-detail__description-text">{{ displayedDescription }}</div>
      <button
        *ngIf="canExpand"
        class="education-detail__read-more"
        (click)="isExpanded = !isExpanded"
      >
        {{ 'shared.read_more' | translate }}
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" [class.rotated]="isExpanded">
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Sticky footer -->
  <div class="education-detail__footer">
    <div class="education-detail__footer-inner">
      <button class="education-detail__footer-btn education-detail__footer-btn--primary">
        {{ 'educations.detail.go_to_course' | translate }}
      </button>
      <button
        class="vacancy-btn-round vacancy-btn-heart"
        [class.vacancy-btn-heart--active]="isSaved"
        (click)="toggleSave()"
        style="width: 48px; height: 48px;"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" [attr.fill]="isSaved ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
        </svg>
      </button>
    </div>
  </div>
</div>
